<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 基本资料</div>
    <ul class="project-info-list">
      <li v-if="project" class="block">
        <label>项目/合同名称：</label>
        <div class="info-item">{{ project.name }}</div>
      </li>
      <li>
        <label>所属单位：</label>
        <div class="info-item">{{ form.department.name }}</div>
      </li>
      <li>
        <label>废弃申请人：</label>
        <div class="info-item">{{ form.creator.name }}</div>
      </li>
      <li class="block intro-box">
        <label>废弃原因：</label>
        <div class="info-item">{{ form.reason }}</div>
      </li>
    </ul>
  </section>
</template>
<script>
  export default {
    props: ['project', 'form', 'userData'],
    data() {
      return {}
    },
    mounted() {},
    methods: {}
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/discardApply.vue